export const useOrderMonitor = (): void => {
  // TODO: maybe useCart().order is good here, but it's overly reactive
};
